export default "__VITE_ASSET__DBSyLZ_V__"